export default __webpack_public_path__ + "static/psoriazal-plus-kak-da-se-spravim-inside-ef603b85034427ed24cd746a2d7dee09.jpg";